import * as Yup from "yup";

export const automationSchema = Yup.object().shape({
    trigger: Yup.string().required("Selecione o gatilho da automação"),
    name: Yup.string().required("Informe o nome da automação").min(3, "Mínimo 3 caracteres"),
    channel: Yup.string().required("Selecione o canal de envio"),
    message: Yup.string().required("Escreva a mensagem").min(10, "Mínimo 10 caracteres"),
    delayDays: Yup.number().min(0, "Valor inválido").integer("Apenas números inteiros"),
    active: Yup.boolean(),
});
